import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { MarketConfigurable } from '@core/domain/impl/market-configurable.impl';
import { getCountryCode } from '@core/infrastructure/state/core.selectors';
import { RgpdData } from '@shared/terms-conditions/models/rgpd-data.model';
import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'app-rgpd-modal',
    templateUrl: './rgpd.component.html',
})
export class RgpdModalComponent extends MarketConfigurable<Record<string, string>> {
    constructor(
        private readonly modalRef: DialogRef,
        private readonly store: Store,
    ) { super(); }

    protected readonly config: Record<string, Record<string, string>> = {
        KR: {
            mspot: 'KR_Terms_Conditions',
        },
        default: {
            mspot: null,
        },
    };

    public readonly data: RgpdData = this.modalRef.data;

    public readonly marketConfig$: Observable<Record<string, string>> = this.store.select(getCountryCode).pipe(
        map(countryCode => this.getConfigByMarketCode(countryCode))
    );

    /**
     * Cierra la modal
     */
    public close(): void {
        this.modalRef.close();
    }
}
